import React, { useState, useEffect } from "react";

import { Worker } from "@react-pdf-viewer/core";

// Core viewer
import { Viewer } from "@react-pdf-viewer/core";

// Plugins
// import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

// Import styles
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

// Create new plugin instance
// const defaultLayoutPluginInstance = defaultLayoutPlugin();

export default function Resume() {
  return (
    <Worker workerUrl="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.3.200/pdf.worker.min.js">
      <div
        style={{
          border: "1px solid rgba(0, 0, 0, 0.3)",
          height: "750px",
        }}
      >
        <Viewer fileUrl="https://orphefs.github.io/static/data/Resume_Orfeas_Kypris_2021.pdf" />
      </div>
    </Worker>
  );
}
